import { render, staticRenderFns } from "./VendorClientDashboard.vue?vue&type=template&id=7968f9a9&scoped=true&"
import script from "./VendorClientDashboard.vue?vue&type=script&lang=js&"
export * from "./VendorClientDashboard.vue?vue&type=script&lang=js&"
import style0 from "./VendorClientDashboard.vue?vue&type=style&index=0&id=7968f9a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7968f9a9",
  null
  
)

export default component.exports